import PrivacyPolicy from '@/views/pages/PrivacyPolicy.vue';
import About from '@/views/pages/About.vue';
import CookiesPolicy from '@/views/pages/CookiesPolicy.vue';
import Donate from '@/views/pages/Donate.vue';
import developers from '@/router/static/developers';

export default [
  {
    path: '/privacy-policy',
    name: 'privacyPolicy',
    component: PrivacyPolicy
  },
  {
    path: '/about',
    name: 'about',
    component: About
  },
  {
    path: '/cookies-policy',
    name: 'cookiesPolicy',
    component: CookiesPolicy
  },
  {
    path: '/donate',
    name: 'donate',
    component: Donate
  },
  ...developers
];
